export const RippleLoaderSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="200px"
    height="200px"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <circle
      cx="50"
      cy="50"
      r="0"
      fill="none"
      className="stroke-brown"
      strokeWidth="2"
    >
      <animate
        attributeName="r"
        repeatCount="indefinite"
        dur="1s"
        values="0;40"
        keyTimes="0;1"
        keySplines="0 0.2 0.8 1"
        calcMode="spline"
        begin="0s"
      ></animate>
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="1s"
        values="1;0"
        keyTimes="0;1"
        keySplines="0.2 0 0.8 1"
        calcMode="spline"
        begin="0s"
      ></animate>
    </circle>
    <circle
      cx="50"
      cy="50"
      r="0"
      fill="none"
      className="stroke-brown"
      strokeWidth="2"
    >
      <animate
        attributeName="r"
        repeatCount="indefinite"
        dur="1s"
        values="0;40"
        keyTimes="0;1"
        keySplines="0 0.2 0.8 1"
        calcMode="spline"
        begin="-0.5s"
      ></animate>
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="1s"
        values="1;0"
        keyTimes="0;1"
        keySplines="0.2 0 0.8 1"
        calcMode="spline"
        begin="-0.5s"
      ></animate>
    </circle>
  </svg>
);
export const ResetLock = (props) => (
  <svg
    width="171"
    height="151"
    viewBox="0 0 171 151"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M95.2513 0.083252C136.957 0.083252 170.743 34.0208 170.743 75.4999C170.743 116.979 136.957 150.917 95.2513 150.917C68.78 150.917 45.6271 137.191 32.1275 116.451L44.0433 107.024C54.6771 124.295 73.6067 135.833 95.3267 135.833C111.328 135.833 126.674 129.477 137.989 118.162C149.303 106.847 155.66 91.5013 155.66 75.4999C155.66 59.4985 149.303 44.1525 137.989 32.8378C126.674 21.5231 111.328 15.1666 95.3267 15.1666C64.5567 15.1666 39.2167 38.2441 35.5213 67.9583H56.3363L28.1304 96.0887L0 67.9583H20.2871C24.0579 29.8728 56.1854 0.083252 95.2513 0.083252ZM117.575 62.2266C121.345 62.302 124.438 65.3187 124.438 69.1649V103.932C124.438 107.703 121.345 110.87 117.499 110.87H75.7938C71.9475 110.87 68.8554 107.703 68.8554 103.932V69.1649C68.8554 65.3187 71.9475 62.302 75.7183 62.2266V54.6095C75.7183 43.0707 85.1454 33.7191 96.6088 33.7191C108.148 33.7191 117.575 43.0707 117.575 54.6095V62.2266ZM96.6088 44.2774C90.9525 44.2774 86.2767 48.8778 86.2767 54.6095V62.2266H107.016V54.6095C107.016 48.8778 102.34 44.2774 96.6088 44.2774Z"
      className="fll-secondary_black"
    />
  </svg>
);
export const OutVector = (props) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 4L13.59 5.41L16.17 8H6V10H16.17L13.59 12.58L15 14L20 9L15 4ZM2 2H10V0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H10V16H2V2Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const DashboardVector = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 18H2C0.9 18 0 17.1 0 16V2C0 0.9 0.9 0 2 0H8V18ZM10 18H16C17.1 18 18 17.1 18 16V9H10V18ZM18 7V2C18 0.9 17.1 0 16 0H10V7H18Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const DefaultUser = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V16H16V14C16 11.34 10.67 10 8 10Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const HambergerMenu = (props) => {
  return (
    <svg
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 12H18V10H0V12ZM0 7H18V5H0V7ZM0 0V2H18V0H0Z" fill="white" />
    </svg>
  );
};
export const SucceessVactor = (props) => {
  return (
    <svg
      width="136"
      height="136"
      viewBox="0 0 136 136"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M98.9825 38.165L54.5 82.6475L30.2675 58.4825L20.75 68L54.5 101.75L108.5 47.75L98.9825 38.165ZM68 0.5C30.74 0.5 0.5 30.74 0.5 68C0.5 105.26 30.74 135.5 68 135.5C105.26 135.5 135.5 105.26 135.5 68C135.5 30.74 105.26 0.5 68 0.5ZM68 122C38.165 122 14 97.835 14 68C14 38.165 38.165 14 68 14C97.835 14 122 38.165 122 68C122 97.835 97.835 122 68 122Z"
        className="fll-green"
      />
    </svg>
  );
};
export const DollarVactor = (props) => {
  return (
    <svg
      width="16"
      height="26"
      viewBox="0 0 16 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.7167 11.4417C5.50087 10.6058 4.4667 9.74167 4.4667 8.39583C4.4667 6.85167 5.89754 5.775 8.2917 5.775C10.8134 5.775 11.7484 6.97917 11.8334 8.75H14.9642C14.865 6.31333 13.3775 4.075 10.4167 3.3525V0.25H6.1667V3.31C3.41837 3.905 1.20837 5.69 1.20837 8.42417C1.20837 11.6967 3.9142 13.3258 7.8667 14.275C11.4084 15.125 12.1167 16.3717 12.1167 17.6892C12.1167 18.6667 11.4225 20.225 8.2917 20.225C5.37337 20.225 4.22587 18.9217 4.07004 17.25H0.953369C1.12337 20.3525 3.4467 22.095 6.1667 22.6758V25.75H10.4167V22.7042C13.1792 22.18 15.375 20.5792 15.375 17.675C15.375 13.6517 11.9325 12.2775 8.7167 11.4417Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Calender = (props) => {
  return (
    <svg
      width="26"
      height="30"
      viewBox="0 0 26 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.08333 29.1667C2.30417 29.1667 1.63715 28.8893 1.08229 28.3344C0.527431 27.7796 0.25 27.1125 0.25 26.3334V6.50004C0.25 5.72087 0.527431 5.05386 1.08229 4.499C1.63715 3.94414 2.30417 3.66671 3.08333 3.66671H4.5V0.833374H7.33333V3.66671H18.6667V0.833374H21.5V3.66671H22.9167C23.6958 3.66671 24.3628 3.94414 24.9177 4.499C25.4726 5.05386 25.75 5.72087 25.75 6.50004V26.3334C25.75 27.1125 25.4726 27.7796 24.9177 28.3344C24.3628 28.8893 23.6958 29.1667 22.9167 29.1667H3.08333ZM3.08333 26.3334H22.9167V12.1667H3.08333V26.3334ZM3.08333 9.33337H22.9167V6.50004H3.08333V9.33337ZM13 17.8334C12.5986 17.8334 12.2622 17.6976 11.9906 17.4261C11.7191 17.1546 11.5833 16.8181 11.5833 16.4167C11.5833 16.0153 11.7191 15.6789 11.9906 15.4073C12.2622 15.1358 12.5986 15 13 15C13.4014 15 13.7378 15.1358 14.0094 15.4073C14.2809 15.6789 14.4167 16.0153 14.4167 16.4167C14.4167 16.8181 14.2809 17.1546 14.0094 17.4261C13.7378 17.6976 13.4014 17.8334 13 17.8334ZM7.33333 17.8334C6.93194 17.8334 6.59549 17.6976 6.32396 17.4261C6.05243 17.1546 5.91667 16.8181 5.91667 16.4167C5.91667 16.0153 6.05243 15.6789 6.32396 15.4073C6.59549 15.1358 6.93194 15 7.33333 15C7.73472 15 8.07118 15.1358 8.34271 15.4073C8.61424 15.6789 8.75 16.0153 8.75 16.4167C8.75 16.8181 8.61424 17.1546 8.34271 17.4261C8.07118 17.6976 7.73472 17.8334 7.33333 17.8334ZM18.6667 17.8334C18.2653 17.8334 17.9288 17.6976 17.6573 17.4261C17.3858 17.1546 17.25 16.8181 17.25 16.4167C17.25 16.0153 17.3858 15.6789 17.6573 15.4073C17.9288 15.1358 18.2653 15 18.6667 15C19.0681 15 19.4045 15.1358 19.676 15.4073C19.9476 15.6789 20.0833 16.0153 20.0833 16.4167C20.0833 16.8181 19.9476 17.1546 19.676 17.4261C19.4045 17.6976 19.0681 17.8334 18.6667 17.8334ZM13 23.5C12.5986 23.5 12.2622 23.3643 11.9906 23.0928C11.7191 22.8212 11.5833 22.4848 11.5833 22.0834C11.5833 21.682 11.7191 21.3455 11.9906 21.074C12.2622 20.8025 12.5986 20.6667 13 20.6667C13.4014 20.6667 13.7378 20.8025 14.0094 21.074C14.2809 21.3455 14.4167 21.682 14.4167 22.0834C14.4167 22.4848 14.2809 22.8212 14.0094 23.0928C13.7378 23.3643 13.4014 23.5 13 23.5ZM7.33333 23.5C6.93194 23.5 6.59549 23.3643 6.32396 23.0928C6.05243 22.8212 5.91667 22.4848 5.91667 22.0834C5.91667 21.682 6.05243 21.3455 6.32396 21.074C6.59549 20.8025 6.93194 20.6667 7.33333 20.6667C7.73472 20.6667 8.07118 20.8025 8.34271 21.074C8.61424 21.3455 8.75 21.682 8.75 22.0834C8.75 22.4848 8.61424 22.8212 8.34271 23.0928C8.07118 23.3643 7.73472 23.5 7.33333 23.5ZM18.6667 23.5C18.2653 23.5 17.9288 23.3643 17.6573 23.0928C17.3858 22.8212 17.25 22.4848 17.25 22.0834C17.25 21.682 17.3858 21.3455 17.6573 21.074C17.9288 20.8025 18.2653 20.6667 18.6667 20.6667C19.0681 20.6667 19.4045 20.8025 19.676 21.074C19.9476 21.3455 20.0833 21.682 20.0833 22.0834C20.0833 22.4848 19.9476 22.8212 19.676 23.0928C19.4045 23.3643 19.0681 23.5 18.6667 23.5Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Paper = (props) => {
  return (
    <svg
      width="26"
      height="30"
      viewBox="0 0 26 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 22.0834H4.5V19.25H21.5V22.0834ZM21.5 16.4167H4.5V13.5834H21.5V16.4167ZM21.5 10.75H4.5V7.91671H21.5V10.75ZM0.25 29.1667L2.375 27.0417L4.5 29.1667L6.625 27.0417L8.75 29.1667L10.875 27.0417L13 29.1667L15.125 27.0417L17.25 29.1667L19.375 27.0417L21.5 29.1667L23.625 27.0417L25.75 29.1667V0.833374L23.625 2.95837L21.5 0.833374L19.375 2.95837L17.25 0.833374L15.125 2.95837L13 0.833374L10.875 2.95837L8.75 0.833374L6.625 2.95837L4.5 0.833374L2.375 2.95837L0.25 0.833374V29.1667Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Breadcrumbs = (props) => {
  return (
    <svg
      width="8"
      height="10"
      viewBox="0 0 8 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.0876 0L0.912598 1.175L4.72926 5L0.912598 8.825L2.0876 10L7.0876 5L2.0876 0Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Plus = ({ pathClass, ...props }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.8332 6.83329H6.83317V11.8333H5.1665V6.83329H0.166504V5.16663H5.1665V0.166626H6.83317V5.16663H11.8332V6.83329Z"
        fill="white"
        className={pathClass}
      />
    </svg>
  );
};
export const Search = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.7549 11.255H11.9649L11.6849 10.985C12.6649 9.845 13.2549 8.365 13.2549 6.755C13.2549 3.165 10.3449 0.255005 6.75488 0.255005C3.16488 0.255005 0.254883 3.165 0.254883 6.755C0.254883 10.345 3.16488 13.255 6.75488 13.255C8.36488 13.255 9.84488 12.665 10.9849 11.685L11.2549 11.965V12.755L16.2549 17.745L17.7449 16.255L12.7549 11.255ZM6.75488 11.255C4.26488 11.255 2.25488 9.245 2.25488 6.755C2.25488 4.26501 4.26488 2.255 6.75488 2.255C9.24488 2.255 11.2549 4.26501 11.2549 6.755C11.2549 9.245 9.24488 11.255 6.75488 11.255Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const SortDownArrow = (props) => {
  return (
    <svg
      width="11"
      height="14"
      viewBox="0 0 11 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.6665 10.7575V5.5H7.1665V10.7575H4.9165L7.9165 13.75L10.9165 10.7575H8.6665ZM3.4165 0.25L0.416504 3.2425H2.6665V8.5H4.1665V3.2425H6.4165L3.4165 0.25Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const MoreVert = (props) => {
  return (
    <svg
      width="5"
      height="16"
      viewBox="0 0 5 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.1333 4C3.2333 4 4.1333 3.1 4.1333 2C4.1333 0.9 3.2333 0 2.1333 0C1.0333 0 0.133301 0.9 0.133301 2C0.133301 3.1 1.0333 4 2.1333 4ZM2.1333 6C1.0333 6 0.133301 6.9 0.133301 8C0.133301 9.1 1.0333 10 2.1333 10C3.2333 10 4.1333 9.1 4.1333 8C4.1333 6.9 3.2333 6 2.1333 6ZM2.1333 12C1.0333 12 0.133301 12.9 0.133301 14C0.133301 15.1 1.0333 16 2.1333 16C3.2333 16 4.1333 15.1 4.1333 14C4.1333 12.9 3.2333 12 2.1333 12Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const ArrowBack = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z"
        fill="black"
        fillOpacity="0.87"
      />
    </svg>
  );
};
export const LoaderSvg = ({ pathClass, ...props }) => {
  return (
    <svg
      aria-hidden="true"
      role="status"
      class="inline w-4 h-4 text-white animate-spin"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="#E5E7EB"
        className={pathClass}
      ></path>
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentColor"
        className={pathClass}
      ></path>
    </svg>
  );
};
export const SavedVector = ({ pathClass, ...props }) => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9166 26.75L9.99992 22.5L0.083252 26.75V4.08333C0.083252 2.525 1.35825 1.25 2.91659 1.25H12.8333C11.9408 2.44 11.4166 3.89916 11.4166 5.5C11.4166 9.41 14.5899 12.5833 18.4999 12.5833C18.9816 12.5833 19.4633 12.5408 19.9166 12.4417V26.75ZM18.2591 9.75L14.2499 5.74083L16.2474 3.74333L18.2449 5.74083L23.2599 0.72583L25.2574 2.72333L18.2591 9.75Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const SettingVector = ({ pathClass, ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1401 10.9404C17.1801 10.6404 17.2001 10.3304 17.2001 10.0004C17.2001 9.68039 17.1801 9.36039 17.1301 9.06039L19.1601 7.48039C19.3401 7.34039 19.3901 7.07039 19.2801 6.87039L17.3601 3.55039C17.2401 3.33039 16.9901 3.26039 16.7701 3.33039L14.3801 4.29039C13.8801 3.91039 13.3501 3.59039 12.7601 3.35039L12.4001 0.81039C12.3601 0.57039 12.1601 0.400391 11.9201 0.400391H8.08011C7.84011 0.400391 7.65011 0.57039 7.61011 0.81039L7.25011 3.35039C6.66011 3.59039 6.12011 3.92039 5.63011 4.29039L3.24011 3.33039C3.02011 3.25039 2.77011 3.33039 2.65011 3.55039L0.74011 6.87039C0.62011 7.08039 0.66011 7.34039 0.86011 7.48039L2.89011 9.06039C2.84011 9.36039 2.80011 9.69039 2.80011 10.0004C2.80011 10.3104 2.82011 10.6404 2.87011 10.9404L0.84011 12.5204C0.66011 12.6604 0.61011 12.9304 0.72011 13.1304L2.64011 16.4504C2.76011 16.6704 3.01011 16.7404 3.23011 16.6704L5.62011 15.7104C6.12011 16.0904 6.65011 16.4104 7.24011 16.6504L7.60011 19.1904C7.65011 19.4304 7.84011 19.6004 8.08011 19.6004H11.9201C12.1601 19.6004 12.3601 19.4304 12.3901 19.1904L12.7501 16.6504C13.3401 16.4104 13.8801 16.0904 14.3701 15.7104L16.7601 16.6704C16.9801 16.7504 17.2301 16.6704 17.3501 16.4504L19.2701 13.1304C19.3901 12.9104 19.3401 12.6604 19.1501 12.5204L17.1401 10.9404ZM10.0001 13.6004C8.02011 13.6004 6.40011 11.9804 6.40011 10.0004C6.40011 8.02039 8.02011 6.40039 10.0001 6.40039C11.9801 6.40039 13.6001 8.02039 13.6001 10.0004C13.6001 11.9804 11.9801 13.6004 10.0001 13.6004Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const DeleteIcon = ({ pathClass, ...props }) => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM3.46 8.88L4.87 7.47L7 9.59L9.12 7.47L10.53 8.88L8.41 11L10.53 13.12L9.12 14.53L7 12.41L4.88 14.53L3.47 13.12L5.59 11L3.46 8.88ZM10.5 1L9.5 0H4.5L3.5 1H0V3H14V1H10.5Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const DeleteVector = ({ pathClass, ...props }) => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1Z"
        className="fill-black"
      />
    </svg>
  );
};
export const FileUpload = (props) => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_4634_16718)">
        <path
          d="M3 20C3 10.0589 11.0589 2 21 2C30.9411 2 39 10.0589 39 20C39 29.9411 30.9411 38 21 38C11.0589 38 3 29.9411 3 20Z"
          fill="white"
        />
        <path
          d="M3 20C3 10.0589 11.0589 2 21 2C30.9411 2 39 10.0589 39 20C39 29.9411 30.9411 38 21 38C11.0589 38 3 29.9411 3 20Z"
          stroke="#E0E0E0"
        />
        <path
          d="M20.165 23.3339C20.165 23.795 20.5388 24.1689 21 24.1689C21.4612 24.1689 21.835 23.795 21.835 23.3339H20.165ZM21.835 14.1672C21.835 13.706 21.4612 13.3322 21 13.3322C20.5388 13.3322 20.165 13.706 20.165 14.1672L21.835 14.1672ZM23.7429 16.4243C24.069 16.7504 24.5977 16.7504 24.9238 16.4243C25.2499 16.0982 25.2499 15.5695 24.9238 15.2434L23.7429 16.4243ZM21.5893 13.0898L20.9988 13.6802L21.5893 13.0898ZM20.4107 13.0898L21.0012 13.6802L21.0012 13.6802L20.4107 13.0898ZM17.0762 15.2434C16.7501 15.5695 16.7501 16.0982 17.0762 16.4243C17.4023 16.7504 17.931 16.7504 18.2571 16.4243L17.0762 15.2434ZM14.335 23.3339C14.335 22.8727 13.9612 22.4989 13.5 22.4989C13.0388 22.4989 12.665 22.8727 12.665 23.3339H14.335ZM29.335 23.3339C29.335 22.8727 28.9612 22.4989 28.5 22.4989C28.0388 22.4989 27.665 22.8727 27.665 23.3339H29.335ZM27.135 27.228L26.7559 26.4841H26.7559L27.135 27.228ZM28.2275 26.1355L28.9715 26.5146V26.5146L28.2275 26.1355ZM13.7725 26.1355L13.0285 26.5146L13.7725 26.1355ZM14.865 27.228L14.4859 27.972H14.4859L14.865 27.228ZM21.835 23.3339L21.835 14.1672L20.165 14.1672L20.165 23.3339H21.835ZM24.9238 15.2434L22.1797 12.4993L20.9988 13.6802L23.7429 16.4243L24.9238 15.2434ZM19.8203 12.4993L17.0762 15.2434L18.2571 16.4243L21.0012 13.6802L19.8203 12.4993ZM22.1797 12.4993C21.5282 11.8478 20.4718 11.8478 19.8203 12.4993L21.0012 13.6802C21.0021 13.6793 21.0016 13.68 21.0002 13.6805C20.9994 13.6808 20.9994 13.6807 21 13.6807C21.0006 13.6807 21.0006 13.6808 20.9998 13.6805C20.9984 13.68 20.9979 13.6793 20.9988 13.6802L22.1797 12.4993ZM12.665 23.3339V23.5005H14.335V23.3339H12.665ZM17.5 28.3355H24.5V26.6655H17.5V28.3355ZM29.335 23.5005V23.3339H27.665V23.5005H29.335ZM24.5 28.3355C25.1863 28.3355 25.7512 28.3362 26.21 28.2987C26.6785 28.2604 27.1093 28.1782 27.5141 27.972L26.7559 26.4841C26.6258 26.5503 26.4392 26.6044 26.074 26.6342C25.699 26.6649 25.2138 26.6655 24.5 26.6655V28.3355ZM27.665 23.5005C27.665 24.2144 27.6644 24.6995 27.6337 25.0745C27.6039 25.4398 27.5498 25.6264 27.4835 25.7564L28.9715 26.5146C29.1777 26.1099 29.2599 25.679 29.2982 25.2105C29.3356 24.7517 29.335 24.1868 29.335 23.5005H27.665ZM27.5141 27.972C28.1416 27.6523 28.6518 27.1421 28.9715 26.5146L27.4835 25.7564C27.3239 26.0697 27.0692 26.3244 26.7559 26.4841L27.5141 27.972ZM12.665 23.5005C12.665 24.1868 12.6644 24.7517 12.7018 25.2105C12.7401 25.679 12.8223 26.1099 13.0285 26.5146L14.5165 25.7564C14.4502 25.6264 14.3961 25.4398 14.3663 25.0745C14.3356 24.6995 14.335 24.2144 14.335 23.5005H12.665ZM17.5 26.6655C16.7862 26.6655 16.301 26.6649 15.926 26.6342C15.5608 26.6044 15.3742 26.5503 15.2441 26.4841L14.4859 27.972C14.8907 28.1782 15.3215 28.2604 15.79 28.2987C16.2488 28.3362 16.8137 28.3355 17.5 28.3355V26.6655ZM13.0285 26.5146C13.3482 27.1421 13.8584 27.6523 14.4859 27.972L15.2441 26.4841C14.9308 26.3244 14.6761 26.0697 14.5165 25.7564L13.0285 26.5146Z"
          fill="black"
          fillOpacity="0.87"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4634_16718"
          x="0.5"
          y="0.5"
          width="41"
          height="41"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4634_16718"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4634_16718"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const AddVector = ({ pathClass, ...props }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z"
        fill="black"
        fillOpacity="0.87"
      />
    </svg>
  );
};
export const FileUploadBack = (props) => {
  return (
    <svg
      width="338"
      height="240"
      viewBox="0 0 338 240"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="338" height="240" rx="4" fill="url(#pattern0_7625_110467)" />
      <defs>
        <pattern
          id="pattern0_7625_110467"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_7625_110467"
            transform="matrix(0.00390625 0 0 0.0055013 0 -0.204167)"
          />
        </pattern>
        <image
          id="image0_7625_110467"
          width="256"
          height="256"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};
export const TickVector = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_8147_2942)">
        <rect x="0.166504" width="24" height="24" rx="12" fill="#1B5E20" />
        <path
          d="M16.7565 7.58L10.1665 14.17L6.5765 10.59L5.1665 12L10.1665 17L18.1665 9L16.7565 7.58ZM12.1665 2C6.6465 2 2.1665 6.48 2.1665 12C2.1665 17.52 6.6465 22 12.1665 22C17.6865 22 22.1665 17.52 22.1665 12C22.1665 6.48 17.6865 2 12.1665 2ZM12.1665 20C7.7465 20 4.1665 16.42 4.1665 12C4.1665 7.58 7.7465 4 12.1665 4C16.5865 4 20.1665 7.58 20.1665 12C20.1665 16.42 16.5865 20 12.1665 20Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_8147_2942">
          <rect x="0.166504" width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Decriment = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#8F6500" />
      <path
        d="M22.5 15C22.5 15.1658 22.4342 15.3247 22.3169 15.4419C22.1997 15.5592 22.0408 15.625 21.875 15.625H8.125C7.95924 15.625 7.80027 15.5592 7.68306 15.4419C7.56585 15.3247 7.5 15.1658 7.5 15C7.5 14.8342 7.56585 14.6753 7.68306 14.5581C7.80027 14.4408 7.95924 14.375 8.125 14.375H21.875C22.0408 14.375 22.1997 14.4408 22.3169 14.5581C22.4342 14.6753 22.5 14.8342 22.5 15Z"
        className="fill-lightBrown"
      />
    </svg>
  );
};
export const Increment = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#8F6500" />
      <path
        d="M22.5 15C22.5 15.1658 22.4342 15.3247 22.3169 15.4419C22.1997 15.5592 22.0408 15.625 21.875 15.625H15.625V21.875C15.625 22.0408 15.5592 22.1997 15.4419 22.3169C15.3247 22.4342 15.1658 22.5 15 22.5C14.8342 22.5 14.6753 22.4342 14.5581 22.3169C14.4408 22.1997 14.375 22.0408 14.375 21.875V15.625H8.125C7.95924 15.625 7.80027 15.5592 7.68306 15.4419C7.56585 15.3247 7.5 15.1658 7.5 15C7.5 14.8342 7.56585 14.6753 7.68306 14.5581C7.80027 14.4408 7.95924 14.375 8.125 14.375H14.375V8.125C14.375 7.95924 14.4408 7.80027 14.5581 7.68306C14.6753 7.56585 14.8342 7.5 15 7.5C15.1658 7.5 15.3247 7.56585 15.4419 7.68306C15.5592 7.80027 15.625 7.95924 15.625 8.125V14.375H21.875C22.0408 14.375 22.1997 14.4408 22.3169 14.5581C22.4342 14.6753 22.5 14.8342 22.5 15Z"
        className="fill-lightBrown"
      />
    </svg>
  );
};
